import { ConfigProvider, message, notification } from "antd";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { CONFIGS } from "./configs/configs";
import { IndexContext } from "./context/IndexContext";
import useThemeSwitcher from "./hooks/useThemeSwitcher";
import MainLayout from "./layout/MainLayout";
import ChangePassword from "./pages/account/ChangePassword";
import UserProfilePage from "./pages/account/UserProfilePage";
import FoodPage from "./pages/configuration/food/FoodPage";
import HomePage from "./pages/home/HomePage";
import LoginPage from "./pages/login/LoginPage";
import ReceiptPage from "./pages/receipt/ReceiptPage";
import TransactionPage from "./pages/transaction/TransactionPage";
import "./styles/index.css";

const App = () => {
  // load theme switcher
  const [appTheme, updateTheme, isLightTheme] = useThemeSwitcher();

  // for triggering message
  const [messageApi, messageApiContext] = message.useMessage();

  // for triggering notification
  const [notificationApi, notificationApiContext] =
    notification.useNotification();

  return (
    <ConfigProvider theme={{ ...appTheme }}>
      {messageApiContext}
      {notificationApiContext}
      <IndexContext.Provider
        value={{
          messageApi: messageApi,
          notificationApi: notificationApi,
          isLightTheme: isLightTheme,
          updateTheme: updateTheme,
        }}
      >
        <BrowserRouter basename={CONFIGS.route_basename}>
          <Routes>
            {/* Login Route */}
            <Route path="login" element={<LoginPage />}></Route>
            {/* All content pages */}
            <Route element={<MainLayout updateTheme={updateTheme} />}>
              <Route path="Home" element={<HomePage />}></Route>
              <Route path="Transaction" element={<TransactionPage />}></Route>
              <Route path="Configuration">
                <Route path="Food" element={<FoodPage />}></Route>
              </Route>
              {/* Sub route for Account */}
              <Route path="Account">
                <Route path="UserProfile" element={<UserProfilePage />}></Route>
                <Route
                  path="ChangePassword"
                  element={<ChangePassword />}
                ></Route>
              </Route>
            </Route>
            {/* QR code Receipt page */}
            <Route path="Receipt" element={<ReceiptPage />} />
            {/* Default all unknown route to login page */}
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </BrowserRouter>
      </IndexContext.Provider>
    </ConfigProvider>
  );
};

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
